<div class="headerbanner" >
      <div>
            <timebanner-component></timebanner-component>
      </div>
      <div>
            <playlistbanner-component></playlistbanner-component>
      </div>
</div>